var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.551 7.83849L12.6662 0.564745C11.7486 -0.188248 10.2473 -0.188248 9.32754 0.564745L0.472331 7.80507C-0.44533 8.55806 0.0642466 9.79226 1.22718 9.79226H2.04123V18.024C2.04123 19.1156 2.88066 20 3.91673 20H4.7477H8.70379V14.9674C8.70379 13.7421 9.65528 12.7396 10.8182 12.7396H11.1777C12.3406 12.7396 13.2921 13.7421 13.2921 14.9674V20H17.2482H18.0791C19.1152 20 19.9546 19.1156 19.9546 18.024V9.79226H20.8469C22.3461 9.79226 22.1558 8.3286 21.551 7.83849Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard_icon.1c58dc9a369128653d57e84d12f28fa4.svg";
export { ForwardRef as ReactComponent };